import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { RecaptchaComponent } from 'angular-google-recaptcha';
import { AuthenticationService } from '../../../providers/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-recuperar-dialog',
  templateUrl: './recuperar-dialog.component.html',
  styleUrls: ['./recuperar-dialog.component.scss']
})
export class RecuperarDialog {
  recaptcha: boolean;
  error: string = '';
  cargando: boolean = true;

  @ViewChild(RecaptchaComponent) recaptchaContainer: RecaptchaComponent;

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  constructor(
    public dialogRecuperar: MatDialogRef<RecuperarDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private authenticationService: AuthenticationService,
    public deviceService: DeviceDetectorService
  ) { }

  onRecatchaLoad() { // cargo el catpcha
    this.cargando = false;
  }

  onRecatchaError() {
    this.error = 'Error de captcha';
  }

  onInput(): void {
    this.error = '';
  }

  onCancelar(): void {
    this.dialogRecuperar.close();
  }

  onRecuperar(): void {
    if (!this.recaptcha ||
      this.emailFormControl.hasError('required') ||
      this.emailFormControl.hasError('email')) {
      this.emailFormControl.markAsTouched();

      this.error = "Revise los datos solicitados y el captcha";
    } else {
      this.authenticationService.recuperarContrasena(this.emailFormControl.value).subscribe(
        respuesta => {
          if (respuesta.estado == 1) {
            this.snackBar.open(respuesta.mensaje, 'OK', { duration: null });
            this.dialogRecuperar.close();
          } else {
            // error en el servidor
            this.error = respuesta.mensaje;
          }

          this.cargando = false;
        },
        () => {
          this.cargando = false;
          this.error = 'Ocurrió un error, comuníquese con el administrador del sistema';
        }
      );
    }
  }
}
